(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arcos-black-friday"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = scope => {
    const roots = [...scope.querySelectorAll('[data-arcos-bf]')];
    if (scope.matches?.('[data-arcos-bf]')) roots.unshift(scope);
    if (!roots.some(root => !root.dataset.bfReady)) return;
    if (window.arcosBFMount) { window.arcosBFMount(scope); return; }
    if (window.arcosBFLoading) return;
    const url = roots[0]?.dataset.bfScript;
    if (!url) return;
    window.arcosBFLoading = true;
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => { window.arcosBFLoading = false; window.arcosBFMount?.(document); };
    script.onerror = () => { window.arcosBFLoading = false; };
    document.head.appendChild(script);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once:true});
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arcos-halloween-suscriptores"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('arcos-subscriber-strip')) return;
    class ArcosSubscriberStrip extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.link = this.querySelector('[data-newsletter-link]');
        if (!this.link) {
          if (!this.awaitingChildren) {
            this.awaitingChildren = true;
            requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
          }
          return;
        }
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.fallbackHref = this.link.getAttribute('href');
        this.resolveTarget();
        this.resolveProducts();
        document.addEventListener('DOMContentLoaded', () => this.resolveTarget(), options);
        requestAnimationFrame(() => { if (this.isConnected) { this.resolveTarget(); this.resolveProducts(); } });
        const productsLink = this.querySelector('[data-products-link]');
        productsLink?.addEventListener('click', event => {
          const destination = this.resolveProducts();
          if (!destination || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: Math.max(0, destination.getBoundingClientRect().top + window.scrollY - 110), behavior: reducedMotion ? 'instant' : 'smooth' });
          if (event.detail === 0) {
            const firstLink = destination.querySelector('.product-card-title, a');
            firstLink?.focus({ preventScroll: true });
          }
        }, options);
        this.link.addEventListener('click', event => {
          const destination = this.resolveTarget();
          if (!destination || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const position = destination.wrapper.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: Math.max(0, position), behavior: reducedMotion ? 'instant' : 'smooth' });
          if (event.detail === 0) destination.email.focus({ preventScroll: true });
        }, options);
        document.addEventListener('shopify:section:load', () => { this.resolveTarget(); this.resolveProducts(); }, options);
        document.addEventListener('shopify:section:unload', () => {
          requestAnimationFrame(() => { if (this.isConnected) { this.resolveTarget(); this.resolveProducts(); } });
        }, options);
      }
      resolveProducts() {
        const link = this.querySelector('[data-products-link]');
        if (!link) return null;
        const candidates = [...document.querySelectorAll('arcos-halloween-collection, .featured-collection')];
        const destination = candidates.find(element => this.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING);
        const target = destination?.id ? destination : destination?.closest('[id]');
        if (target?.id) link.setAttribute('href', `#${target.id}`);
        return destination || null;
      }
      resolveTarget() {
        let email;
        const targetId = this.dataset.targetId?.trim().replace(/^#/, '');
        if (targetId) {
          const explicit = document.getElementById(targetId);
          email = explicit?.matches('input[name="contact[email]"]') ? explicit : explicit?.querySelector('input[name="contact[email]"]');
        }
        if (!email) {
          const candidates = [...document.querySelectorAll('.email-signup input[name="contact[email]"]')];
          email = candidates.find(input => {
            const section = input.closest('.email-signup');
            return section && (this.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING);
          });
        }
        if (!email?.id) {
          this.link.setAttribute('href', this.fallbackHref);
          return null;
        }
        const wrapper = email.closest('.email-signup') || email;
        this.link.setAttribute('href', `#${email.id}`);
        this.link.setAttribute('aria-controls', email.id);
        return { email, wrapper };
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.awaitingChildren = false;
      }
    }
    customElements.define('arcos-subscriber-strip', ArcosSubscriberStrip);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordika-landing"] && !Shopify.designMode) return;
  try {
    
/* Scoped, editor-safe custom elements. No cart replacement: native ProductCard handles cart. */
(()=>{
 if(!customElements.get('nk-catalog'))customElements.define('nk-catalog',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const products=[...this.querySelectorAll('[data-nk-product]')];
   const initial=Math.max(1,Number(this.dataset.initial)||6),button=this.querySelector('[data-expand]'),output=this.querySelector('[data-summary-output]');
   const update=n=>{output.textContent=(this.dataset.summary||'').replaceAll('[shown]',String(n)).replaceAll('[total]',String(products.length))};
   products.forEach((p,i)=>p.hidden=i>=initial);button.hidden=products.length<=initial;update(Math.min(products.length,initial));
   button.addEventListener('click',()=>{
    products.forEach(p=>{p.hidden=false;p.querySelectorAll('.lazyload').forEach(img=>window.lazySizes?.loader?.unveil(img))});
    update(products.length);button.setAttribute('aria-expanded','true');
    const next=products[initial]?.querySelector('a,button');if(next)next.focus({preventScroll:true});button.hidden=true;
   });
  }
 });
 if(!customElements.get('nk-films'))customElements.define('nk-films',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};
   const track=this.querySelector('.nk-films'),slides=[...track.children],prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]'),output=this.querySelector('output');
   let current=0;const update=()=>{let distance=Infinity;slides.forEach((s,i)=>{const d=Math.abs(s.getBoundingClientRect().left-track.getBoundingClientRect().left);if(d<distance){distance=d;current=i}});output.textContent=slides.length?`${current+1} / ${slides.length}`:'0 / 0';prev.disabled=current===0;next.disabled=current>=slides.length-1;};
   const move=delta=>{const target=slides[Math.max(0,Math.min(slides.length-1,current+delta))];if(target)track.scrollTo({left:target.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})};
   prev.addEventListener('click',()=>move(-1),opts);next.addEventListener('click',()=>move(1),opts);track.addEventListener('scroll',update,{...opts,passive:true});window.addEventListener('resize',update,opts);
   track.addEventListener('keydown',e=>{if(e.target===track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}},opts);
   if('IntersectionObserver'in window){this.observer=new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;if(e.isIntersecting){v.play().catch(()=>{})}else{v.pause()}}),{threshold:.1});this.querySelectorAll('video').forEach(v=>this.observer.observe(v))}
   document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target))e.target.scrollIntoView({block:'nearest',inline:'start',behavior:'auto'})},opts);update();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect()}
 });
 if(!customElements.get('nk-hotspots'))customElements.define('nk-hotspots',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};
   const details=[...this.querySelectorAll('[data-detail]')],pins=[...this.querySelectorAll('[data-pin]')];
   const sync=()=>pins.forEach(pin=>{const open=details.find(d=>d.dataset.detail===pin.dataset.pin)?.open||false;pin.setAttribute('aria-expanded',String(open));pin.closest('.image-hotspots--pin').classList.toggle('active',open)});
   pins.forEach(pin=>pin.addEventListener('click',()=>{const detail=details.find(d=>d.dataset.detail===pin.dataset.pin);if(detail)detail.querySelector('summary').click()},opts));
   details.forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)details.forEach(other=>{if(other!==detail&&other.open)other.querySelector('summary').click()});sync()},opts));
   document.addEventListener('shopify:block:select',e=>{const pin=e.target.querySelector?.('[data-pin]');if(pin&&this.contains(pin)){const detail=details.find(d=>d.dataset.detail===pin.dataset.pin);if(detail&&!detail.open)detail.querySelector('summary').click()}},opts);sync();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null}
 });
 if(!customElements.get('nk-marquee'))customElements.define('nk-marquee',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;const button=this.querySelector('[data-nk-motion]');if(!button)return;
   button.addEventListener('click',()=>{const paused=document.documentElement.classList.toggle('nk-motion-paused');document.querySelectorAll('[data-nk-motion]').forEach(b=>{b.setAttribute('aria-pressed',String(paused));b.setAttribute('aria-label',paused?b.dataset.play:b.dataset.pause);b.firstElementChild.textContent=paused?'▶':'Ⅱ'})});
  }
 });
})();


  } catch(e) { console.error(e); }
})();
})();
